import React, { useEffect } from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import ErrorIcon from "@mui/icons-material/Error";

import { Emphasize } from "../../../../styles";
import { csActions } from "../../../../../redux/actions";

const UnconnectedStep4Content = (props) => {
  return (
    <>
      {props.isError &&
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing="2px">
          <Grid item>
            <ErrorIcon color="error" fontSize="small" />
          </Grid>
          <Grid item>
            <Typography variant="caption" color="error">{props.errorMessage}</Typography>
          </Grid>
        </Grid>
      }
      <Typography>
        Thank you for your submission.
      </Typography>
      <Typography sx={{marginTop: "20px"}}>
        Here is your transaction reference ID: <Emphasize>{props.order.receipt.id}</Emphasize>
      </Typography>
      <Typography sx={{marginTop: "20px"}}>
        Mark Laudi will now personally prepare your <Emphasize>Succession Assessment Report</Emphasize> and email it to you in the next 48 hours.
      </Typography>
      <Typography sx={{marginTop: "20px"}}>
        In the meantime, please click on the button below if you wish to book a slot with Mark Laudi.
      </Typography>
      <Link
        href="https://successionplanning.timetap.com/"
        target="_blank"
        rel="noopener"
        sx={{textDecoration: "none"}}
      >
        <Button
          variant="contained"
          sx={{marginTop: "20px"}}
        >
          Book a slot with Mark Laudi
        </Button>
      </Link>
    </>
  )
}

const mapState = (state) => {
  const {
    order,
    isError,
    errorMessage,
  } = state.cs;
  const { id } = state.visitor;
  return {
    order,
    isError,
    errorMessage,
    visitorId: id,
  };
};

const actionCreators = {
};

export const Step4Content = connect(mapState, actionCreators)(UnconnectedStep4Content);